// Centralized query keys for the V2 wizard's React Query hooks.
//
// Keys are scoped under the `'orders_v2'` root so cross-route
// `queryClient.invalidateQueries({ queryKey: ['orders_v2'] })` calls
// can flush every wizard query in one shot. Per-resource sub-keys
// follow `[root, resource, ...inputs]` so that changing any input
// rotates the cache slot — same trigger semantics the hand-rolled
// useEffect dependency arrays had.

const ROOT = 'orders_v2' as const;

export const orderV2QueryKeys = {
  root: [ROOT] as const,
  customersDirectory: (agencyId: number) =>
    [ROOT, 'customers_directory', agencyId] as const,
  orderTemplates: (billingAccountId: number, orderType: string | null) =>
    [ROOT, 'order_templates', billingAccountId, orderType] as const,
  orderTemplate: (templateId: number) =>
    [ROOT, 'order_template', templateId] as const,
  skills: (billingAccountId: number, search: string) =>
    [ROOT, 'skills', billingAccountId, search] as const,
  skillCategories: (billingAccountId: number) =>
    [ROOT, 'skill_categories', billingAccountId] as const,
  paymentMethods: (billingAccountId: number) =>
    [ROOT, 'payment_methods', billingAccountId] as const,
  uniforms: (billingAccountId: number) =>
    [ROOT, 'uniforms', billingAccountId] as const,
  savedSnippets: (billingAccountId: number, fieldKind: string) =>
    [ROOT, 'saved_snippets', billingAccountId, fieldKind] as const,
  locations: (billingAccountId: number) =>
    [ROOT, 'locations', billingAccountId] as const,
  shiftSupervisors: (billingAccountId: number) =>
    [ROOT, 'shift_supervisors', billingAccountId] as const,
  surgeRates: (billingAccountId: number, fromDate: string) =>
    [ROOT, 'surge_rates', billingAccountId, fromDate] as const,
  certificates: (billingAccountId: number) =>
    [ROOT, 'certificates', billingAccountId] as const,
  rateQuote: (billingAccountId: number, skillId: number, addressId: number) =>
    [ROOT, 'rate_quote', billingAccountId, skillId, addressId] as const,
  rateRange: (billingAccountId: number, skillId: number, addressId: number) =>
    [ROOT, 'rate_range', billingAccountId, skillId, addressId] as const,
  verificationFlag: (customerId: number) =>
    [ROOT, 'verification_flag', customerId] as const,
};
